import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import "./styles.scss";
import FileSaver from "../file-saver";
import CustomTab from "../../../assets/component/tab";
import Breadcrumbs from "../../../assets/component/breadcrumbs";
import UnSubscribeUI from "../../../assets/component/page-errors/un-subscribe";
import { GetFolderStructureReset } from "../../../store/slices/custom-research/folder-structure";

const tabOptions = {
    key: 1,
    title: 'Manage My Files',
    value: 'Manage My Files',
    tabs: [

        {
            key: 1.1,
            title: 'My Files',
            payloadType: "Completed",
            requiredFields: ["FILE", "FOLDER", "DELETE"]
        },
        {
            key: 1.2,
            title: 'Sync Pending',
            payloadType: "Pending",
            requiredFields: ["FILE", "FOLDER", "DELETE"]
        },
        {
            key: 1.3,
            title: 'Sync Failed',
            payloadType: "Failed",
            requiredFields: [""]
        },
    ]
}

const ManageFiles = ({ unsubscribe }) => {
    const dispatch = useDispatch()

    const [activeTab, setActiveTab] = useState("");
    const [activeTabDetails, setActiveTabDetails] = useState({});

    const fetchFolders = () => {
        // Reset
        dispatch(GetFolderStructureReset())
    }

    useEffect(() => {
        setActiveTab(tabOptions?.tabs[0]?.payloadType)
        setActiveTabDetails(tabOptions?.tabs[0]?.requiredFields)
        fetchFolders()
    }, [])

    return (
        <div className="manage-files-main">
            <Breadcrumbs />
            {unsubscribe && (<UnSubscribeUI />)}
            <CustomTab tabOptions={tabOptions} setTabValue={setActiveTab} tabValue={activeTab} setTabDetails={setActiveTabDetails}>
                {!unsubscribe && (
                    <div className="manage-file-page-contents">
                        <div className="folder-structure-container">
                            <FileSaver
                                showCreateFolder
                                pageLayout
                                activeTab={activeTab}
                                setActiveTab={setActiveTab}
                                tabOptions={tabOptions}
                                requiredFields={activeTabDetails}
                            />
                        </div>
                    </div>
                )}
            </CustomTab>
        </div>
    )
}

export default ManageFiles